import { render, staticRenderFns } from "./login-logout.vue?vue&type=template&id=5f9089b6"
import script from "./login-logout.vue?vue&type=script&lang=js"
export * from "./login-logout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports